import { jsx as _jsx } from "react/jsx-runtime";
import KodanshaLogoGrey from '../KodanshaAssets/Kodansha_Logo_grey.svg';
import './ImagePlaceholder.scss';
export function ImagePlaceholder(props) {
    return (_jsx("div", { className: "ImagePlaceholder", children: _jsx("img", { src: KodanshaLogoGrey, alt: props.alt }) }));
}
